import { useTranslation } from 'react-i18next';

import {
	PrintPdfDialog,
	PrintPdfDialogProps,
} from 'modules/Shared/PdfPrint/PrintPdfDialog';

import { UnitOverviewDialogContent } from './UnitOverviewDialogContent';
import {
	PrintUnitOverviewUserSettings,
	mapRecordToUnitOverviewUserSettings,
} from './types';
import { unitOverviewSettingsCategory } from './unitOverviewSettingsCategory';

type PrintUnitOverviewDialogProps = Omit<
	PrintPdfDialogProps<PrintUnitOverviewUserSettings, unknown>,
	| 'ContentComponent'
	| 'mapRecordToPdfUserSettings'
	| 'pdfSettingsCategories'
	| 'title'
>;

export const PrintUnitOverviewDialog = (
	props: PrintUnitOverviewDialogProps
) => {
	const { t } = useTranslation('unitOverview');

	return (
		<PrintPdfDialog
			ContentComponent={UnitOverviewDialogContent}
			mapRecordToPdfUserSettings={mapRecordToUnitOverviewUserSettings}
			pdfSettingsCategories={unitOverviewSettingsCategory}
			title={t('unit-preview-print-pdf-dialog-title')}
			{...props}
		/>
	);
};
